<div class="hbo-card"
  [ngStyle]="{
    'border-color': outlineColor || null,
    'box-shadow': outlineColor ? '0 0 20px ' + outlineColor + '55, 0 0 40px ' + outlineColor + '33, 0 10px 15px -3px rgba(0,0,0,0.1)' : null
  }">

  <!-- Header: dark background with logo -->
  <div class="hbo-card__header" [style.backgroundColor]="headerColor || null">
    <div class="hbo-card__header-overlay"></div>
    <img *ngIf="headerLogoImage" [src]="headerLogoImage" class="hbo-card__logo" />
  </div>

  <!-- Body: product image -->
  <div class="hbo-card__body">
    <div class="hbo-card__image-container">
      <div class="hbo-card__radial-glow"></div>
      <img *ngIf="bodyImage" [src]="bodyImage" class="hbo-card__product-image" />
    </div>
  </div>

  <!-- Footer: CTA buttons -->
  <div class="hbo-card__footer">
    <button class="hbo-card__cta" (click)="onCtaClick()">
      {{ ctaText }}
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
        <polyline points="15 3 21 3 21 9"></polyline>
        <line x1="10" y1="14" x2="21" y2="3"></line>
      </svg>
    </button>
    <button *ngIf="secondCtaText" class="hbo-card__cta" (click)="onSecondCtaClick()">
      {{ secondCtaText }}
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
        <polyline points="15 3 21 3 21 9"></polyline>
        <line x1="10" y1="14" x2="21" y2="3"></line>
      </svg>
    </button>
  </div>

</div>